import { HttpResponse } from '@/types/http'
import { AxiosResponse } from 'axios'

export const transformBackend = <R extends AxiosResponse<any>, T = any>(
  res: R
): T => {
  return res?.data
}
// export function transformBackend<R extends AxiosResponse<HttpResponse<any>, T = any>
